module.exports = __webpack_public_path__ + "static/media/download-white.fa2dfb30.svg";